import React, { createContext, useState, useContext } from 'react';

const EnvContext = createContext();

export const EnvProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [username, setUsername] = useState('');
    const [uid, setUid] = useState('');
    const [companyCode, setCompanyCode] = useState('');
    const [userRole, setUserRole] = useState('');
    const [reInitSessionMsg, setReInitSessionMsg] = useState(null);
    const [detailsRenderReady, setDetailsRenderReady] = useState(false);

    return (
        <EnvContext.Provider value={{
            isAuthenticated,
            setIsAuthenticated,
            username,
            uid,
            companyCode,
            userRole,
            reInitSessionMsg,
            detailsRenderReady,
            setUsername,
            setUid,
            setCompanyCode,
            setUserRole,
            setReInitSessionMsg,
            setDetailsRenderReady,
        }}>
            {children}
        </EnvContext.Provider>
    );
};

export const useEnv = () => {
    const context = useContext(EnvContext);
    if (context === undefined) {
        throw new Error('useEnv must be used within an EnvProvider');
    }
    return context;
};
